"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsInnerToJSON = exports.ProductsInnerFromJSONTyped = exports.ProductsInnerFromJSON = exports.instanceOfProductsInner = void 0;
var runtime_1 = require("../runtime");
var ProductsInnerProductCollectionsInner_1 = require("./ProductsInnerProductCollectionsInner");
var ProductsInnerVariantsInner_1 = require("./ProductsInnerVariantsInner");
/**
 * Check if a given object implements the ProductsInner interface.
 */
function instanceOfProductsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductsInner = instanceOfProductsInner;
function ProductsInnerFromJSON(json) {
    return ProductsInnerFromJSONTyped(json, false);
}
exports.ProductsInnerFromJSON = ProductsInnerFromJSON;
function ProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'active': !(0, runtime_1.exists)(json, 'active') ? undefined : json['active'],
        'styleId': !(0, runtime_1.exists)(json, 'style_id') ? undefined : json['style_id'],
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : json['price'],
        'imageUrl': !(0, runtime_1.exists)(json, 'image_url') ? undefined : json['image_url'],
        'variants': !(0, runtime_1.exists)(json, 'variants') ? undefined : (json['variants'].map(ProductsInnerVariantsInner_1.ProductsInnerVariantsInnerFromJSON)),
        'productCollections': !(0, runtime_1.exists)(json, 'product_collections') ? undefined : (json['product_collections'].map(ProductsInnerProductCollectionsInner_1.ProductsInnerProductCollectionsInnerFromJSON)),
    };
}
exports.ProductsInnerFromJSONTyped = ProductsInnerFromJSONTyped;
function ProductsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'style_id': value.styleId,
        'price': value.price,
        'image_url': value.imageUrl,
        'variants': value.variants === undefined ? undefined : (value.variants.map(ProductsInnerVariantsInner_1.ProductsInnerVariantsInnerToJSON)),
        'product_collections': value.productCollections === undefined ? undefined : (value.productCollections.map(ProductsInnerProductCollectionsInner_1.ProductsInnerProductCollectionsInnerToJSON)),
    };
}
exports.ProductsInnerToJSON = ProductsInnerToJSON;
